import React from 'react';

const HEATMAP_TYPES = [
  { value: 'flash', label: 'Onsight/Flash' },
  { value: 'clean', label: 'Clean Sends' },
  { value: 'attempts', label: 'All Attempts' }
];

const TIME_PERIODS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'half-yearly', label: '6-Monthly' },
  { value: 'yearly', label: 'Yearly' }
];

export const HeatmapControls = ({
  heatmapType,
  setHeatmapType,
  timePeriod,
  setTimePeriod
}) => {
  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">View:</span>
        <select
          value={heatmapType}
          onChange={(e) => setHeatmapType(e.target.value)}
          className="px-2 py-1 text-sm rounded border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {HEATMAP_TYPES.map(type => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">Period:</span>
        <select
          value={timePeriod}
          onChange={(e) => setTimePeriod(e.target.value)}
          className="px-2 py-1 text-sm rounded border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {TIME_PERIODS.map(period => (
            <option key={period.value} value={period.value}>
              {period.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default HeatmapControls;
